import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { LockOutlined as LockOutlinedIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

/**
 * Read-only notice shown when a positively-identified viewer-only user reaches an
 * edit-oriented route (via a direct URL / deep link). Editing surfaces would 403
 * for these users; this explains why instead of showing a broken editor page.
 */
const AccessRestricted: React.FC = () => {
  useDocumentTitle('Read-only access');
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        role="alert"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: 2,
          p: 4,
          minHeight: '60vh',
        }}
      >
        <LockOutlinedIcon color="action" sx={{ fontSize: 48 }} />
        <Typography variant="h5">This area is read-only for your account</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 480 }}>
          Editing data sources, pipelines, transformations, models and dashboards requires an editor
          role. Your account has view-only access, so this page is not available to you. You can
          still explore your data, dashboards and lineage.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => navigate('/')}>
          Go to Your Data
        </Button>
      </Box>
    </Container>
  );
};

export default AccessRestricted;
